import React from 'react';
import { number } from 'prop-types';
import cn from 'classnames';
import i18next from 'i18next';
import { Trans } from 'react-i18next';

import CrossButton from '~components/CrossButton';
import { ReactComponent as CircleCheck } from '~assets/circle_check.svg';
import { upsellingVariantPropTypes } from '~propTypes/shoppingCart';

import { useFitFontSize, useUpsellingOption } from './hooks';
import styles from './styles.module.scss';
import { ICON_DECORATIONS, MAX_HEIGHT } from './constants';

function UpsellingOption({ upsellingVariant, quantity, index, productId }) {
  const containerRef = useFitFontSize({ maxHeight: MAX_HEIGHT });
  const {
    onClickContainer,
    onClickCrossButton,
    hidden,
    animationHidden,
    Icon,
    loading,
    transComponentProps
  } = useUpsellingOption({
    productId,
    index,
    quantity,
    upsellingVariant
  });
  const { isUpgraded } = upsellingVariant;

  return (
    <div
      className={cn(styles.container, {
        [styles.clickable]: !isUpgraded,
        [styles.loading]: loading
      })}
      onClick={onClickContainer}>
      <div className={styles.iconContainer}>
        {Icon}
        <CircleCheck className={cn(styles.iconDecoration, hidden)} />
        {ICON_DECORATIONS.map(({ id, Component, className }) => (
          <Component key={id} className={cn(className, animationHidden)} />
        ))}
      </div>
      <p className={styles.description} ref={containerRef}>
        <Trans shouldUnescape i18n={i18next} components={{ bold: <span /> }} {...transComponentProps} />
      </p>
      <CrossButton
        className={cn(styles.crossButtonIcon, hidden)}
        containerClassName={styles.crossButtonContainer}
        onClick={onClickCrossButton}
      />
    </div>
  );
}

UpsellingOption.propTypes = {
  index: number,
  productId: number,
  quantity: number,
  upsellingVariant: upsellingVariantPropTypes
};

export default UpsellingOption;
